<template>
  <div id="multiCascader">
    <div class="container">
      <el-cascader @mouseenter.native="show = false" @mouseleave.native="show = true" :show-all-levels="showAllLevels" v-bind="$attrs" v-model="input" v-on="$listeners" :options="options" @change="onChange" :placeholder="placeholder" :style="styleObj"
                   :class="editMode ? 'pt-multi-cascader-edit' : 'pt-multi-cascader'">
      </el-cascader>
      <div class="suffix-icon" v-if="iconShow">
        <a-icon type="caret-down" />
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'multiCascader',
    props: {
      editMode:{
        type:Boolean,
        default: true
      },
      styleObj:{
        type:Object,
        default:()=> {return {width:'100%'}},
      },
      options:{
        type:Array,
      },
      placeholder:{
        type:String,
      },
      value:{
        type:Array,
      },
      showAllLevels:{
        type:Boolean,
        default:true
      }
    },
    data() {
      return {
        input:this.value,
        show:true,
      }
    },
    mounted() {

    },
    computed:{
      iconShow(){
        return this.editMode &&  (this.show ||  !this.input || this.input.length == 0)
      }
    },
    methods: {
      onChange(value){
        this.$emit('input',value)
        this.$emit('changeValue',value);
      }
    },
    watch:{
      value (val) {
        this.input = val
      },
    },
  }
</script>

<style scoped lang="less">
  .container{
    position: relative;
    .suffix-icon{
      position: absolute;
      right: 0;
      top: 10px;
      font-size: 12px;
      color:  rgba(0, 0, 0, 0.25);
      padding-right:10px;
    }
  }
  .pt-multi-cascader-edit{
    /deep/ .el-input__inner{
      background-color: transparent;
      border-bottom: 1px solid #BCBCBC;
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
    /deep/ .el-input__inner:hover{
      border-bottom: 1px solid #FABE00;
    }
    /deep/ .el-input__inner:focus{
      border-color: #FABE00 !important;
    }
    /deep/ .el-icon-arrow-down{
      display: none;
    }
  }
  .el-cascader .el-input .el-input__inner:focus{
    border-color: #FABE00 !important;
  }
  .pt-multi-cascader{
    /deep/ .el-input__inner{
      background-color: transparent;
      border: none;
    }
    /deep/ .el-icon-arrow-down{
      display: none;
    }
  }
</style>